import { TestImage } from "@assets/constant/index.constant";
import { endpoint } from "@services/api.services";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { StudentPlacementData } from "@utils/interface/journey.interface";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { format } from "date-fns";
import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import StudentPlacementForm from "./form/index.form";
import FilterPopover from "@ui/internal/components/filter-popover";

const index = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { search, date } = useMetaStore();
  const pathname = usePathname();
  /* ================================================= api calls logic ================================================= */
  const { data, isPending, refetch, error } = useListData<
    QueryData<StudentPlacementData>
  >({
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
      created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
      ordering: searchParams.get("ordering") || "order",
      student__id: searchParams.get("student") || "",
    },
    endpoint: endpoint["student-placement"],
    key: `${pathname}-listing`,
    window: false,
  });
  // rollback
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const columns = ColumnList({ refetch });
  return (
    <>
      <TableCard
        table_content={{
          mode: "default",
          type: pathname,
        }}
        bulkActions
        orientationPosition={false}
        grid={
          <GeneralCard
            isChecked={false}
            type={"mentor"}
            content={{
              images: [TestImage],
              title:
                "Inside the Journey: Ranjana Sharma's UI/UX Adventure at Skillshikshya",
              subtitle:
                "From a newbie to an industry pro, SkillShikshya transformed my journey Ranjana Sharma's UI/UX Adventure at SkillshikshyaRanjana Sharma's UI/UX Adventure at SkillshikshyaRanjana Sharma's UI/UX Adventure at SkillshikshyaRanjana Sharma's UI/UX Adventure at SkillshikshyaRanjana Sharma's UI/UX Adventure at Skillshikshya.",
            }}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        inject_ui_table_actions={
          <>
            <FilterPopover
              filters={[
                {
                  label: "Student",
                  endpointValue: "student",

                  format: {
                    key: "email",
                    value: "id",
                  },
                },
              ]}
              title="Filter"
              triggerText="Filter"
            />
          </>
        }
        endpoint={endpoint["student-placement"]}
        columns={columns}
        refetch={refetch}
        isPending={isPending}
        rows={data?.data?.results ?? []}
        sortableFilter={{
          search,
          created_date__gte: date.from ? format(date.from, "yyyy-MM-dd") : "",
          created_date__lte: date.to ? format(date.to, "yyyy-MM-dd") : "",
          ordering: searchParams.get("ordering") || "order",
          student__id: searchParams.get("student") || "",
        }}
        count={data?.data?.count ?? 10}
        form={<StudentPlacementForm />}
      />
    </>
  );
};

export default index;
